import React from 'react';
import './RefundTableSkeleton.css';

const RefundTableSkeleton = () => {
  const rows = Array.from({ length: 10 });

  return (
    <div className="refund-table-skeleton">
      <div className="refund-table-skeleton-thead">
        <div className="refund-table-skeleton-th" />
        <div className="refund-table-skeleton-th" />
        <div className="refund-table-skeleton-th" />
        <div className="refund-table-skeleton-th" />
        <div className="refund-table-skeleton-th" />
        <div className="refund-table-skeleton-th" />
      </div>
      <div className="refund-table-skeleton-tbody">
        {rows.map((_, idx) => (
          <div className="refund-table-skeleton-tr" key={idx}>
            <div className="refund-table-skeleton-td">
              <div className="refund-table-skeleton-line sm" />
            </div>
            <div className="refund-table-skeleton-td">
              <div className="refund-table-skeleton-line md" />
            </div>
            <div className="refund-table-skeleton-td">
              <div className="refund-table-skeleton-badge" />
            </div>
            <div className="refund-table-skeleton-td">
              <div className="refund-table-skeleton-line sm" />
            </div>
            <div className="refund-table-skeleton-td">
              <div className="refund-table-skeleton-line xs" />
            </div>
            <div className="refund-table-skeleton-td">
              <div className="refund-table-skeleton-badge" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RefundTableSkeleton;
